const tabSelect = document.querySelector(
  '.tab-select select'
) as HTMLSelectElement

if (tabSelect) {
  document
    .querySelectorAll('.tab-select .select-items div')
    .forEach((selectDiv, index) =>
      selectDiv.addEventListener('click', () => {
        // Update the select element's value
        tabSelect.selectedIndex = index + 1 // +1 because first option is "Thema auswählen"

        // Get the corresponding option value from the select element
        const selectedValue = tabSelect.options[tabSelect.selectedIndex].value

        // Update tabs
        document
          .querySelectorAll('.tab-pane')
          .forEach((pane) => pane.classList.remove('show', 'active'))

        document.getElementById(selectedValue)?.classList.add('show', 'active')

        // Update visual state of the custom select
        const selectedText = selectDiv.innerHTML // Get HTML including any nested spans
        const selectSelected = document.querySelector(
          '.tab-select .select-selected'
        )
        if (selectSelected) {
          selectSelected.innerHTML = selectedText
        }

        // Remove 'same-as-selected' from all divs
        document
          .querySelectorAll('.tab-select .select-items div')
          .forEach((div) => {
            div.classList.remove('same-as-selected')
          })

        // Add 'same-as-selected' to the clicked div
        selectDiv.classList.add('same-as-selected')
      })
    )
}
